import { usePlatformUpdate } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'

export interface DeleteAgreementPayload {
  iDs: string[]
}

export const useDeleteAgreement = () => {
  const path: string = '/api/User/Document/Delete'

  const [deleteAgreement, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    DeleteAgreementPayload,
    IDocuments
  >({
    path: path,
    method: 'DELETE',
    headers: {},
    errorMessage: 'Failed to delete the agreement',
    successMessage: 'Agreement successfully deleted',
  })

  return { deleteAgreement, returnData, isLoading, isSuccess, isError }
}
